import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import Image from '../Image/Image';
import Video from '../Video/Video';
import VideoEmbed from '../VideoEmbed/VideoEmbed';
import s from './BackgroundMedia.scss';

const BackgroundMedia = ({ content, column, uid, first = false, focalPoint = false, fill = false, showPlay = false, lazyLoad = true }) => {
	const extraProps = {};
	const [isPlaying, togglePlaying] = useState(false);
	const removeCoverImage = (e) => {
		e.preventDefault();
		togglePlaying(true);
	};
	let Wrapper = ({ children }) => children;

	if (focalPoint) {
		const objectPosition = `${(parseFloat(focalPoint.x, 10) * 100).toFixed(1)}% ${(parseFloat(focalPoint.y, 10) * 100).toFixed(1)}%`;
		extraProps.style = { objectPosition };
		extraProps['data-object-fit'] = 'cover';
		extraProps['data-object-position'] = objectPosition;
	}
	if (fill) extraProps['data-object-fit'] = 'cover';

	const media = !Array.isArray(content.image) ? [content.image] : content.image;
	const embeds = !Array.isArray(content.embedLink) ? [content.embedLink] : content.embedLink;
	const containerProps = {};
	if (content.overlayColor) containerProps.style = { backgroundColor: content.overlayColor };

	const returnContent = media.filter((image) => image).map((image) => {
		if (!image) return null;
		if (/\.mp4$/.test(image.url)) return <div key={image.url} className={[s.media_item, s.media_item__video].join(' ')}><Video content={{ src: image.url, autoplay: 1, loop: 1, muted: 1 }} column={column} extraProps={extraProps} lazyLoad={lazyLoad} enableEvents={false} /></div>;
		return <div key={image.url} className={[s.media_item, s.media_item__image].join(' ')}><Image content={{ image }} column={column} extraProps={extraProps} first={first} lazyLoad={lazyLoad} /></div>;
	});

	embeds.forEach((embed) => {
		if (!embed) return;
		returnContent[returnContent.length] = <div key={embed} className={[s.media_item, s.media_item__video].join(' ')}><VideoEmbed content={{ url: embed }} uid={uid} extraProps={extraProps} lazyLoad={lazyLoad} isMute={returnContent.length === 0} /></div>;
	});

	if (returnContent.length > 1) {
		Wrapper = ({ children }) => (
			<a href="#play-embed" onClick={removeCoverImage}>
				{ children }
			</a>
		);
	}

	return (
		<div className={[s.media, (content.transparentMenu ? s.media__fullHeight : null), (fill ? s.media__fill : null), (returnContent.length > 1 ? s.media__multiple : null)].join(' ')} {...containerProps}>
			<Wrapper>
				{ returnContent.length > 1 && !isPlaying && showPlay && <svg className={s.media_playButton} width="45" height="72" viewBox="0 0 45 72" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M45 36L4.70468e-07 71.507L3.57459e-06 0.492956L45 36Z" fill="white" fillOpacity="1" /></svg> }
				{ returnContent.length > 1 && !isPlaying && returnContent.slice(0, 1) }
				{ returnContent.length > 1 && isPlaying && returnContent.slice(1) }
				{ returnContent.length === 1 && returnContent }
			</Wrapper>
		</div>
	);
};

export default hot(module)(BackgroundMedia);
